export const css = {
    root: 'jnjTypNi',
    content: '_3e_szuav',
    loading: '_30XBnXRA',
    promote: '_1fvn0HST',
    disabledPromote: 'K1a9ZhWh',
    domain: '_34LlIg7S',
    title: '_3T7PpiRh',
    subtitle: 'zl4L_vcP',
    actions: 'q69qpJHI',
    indicator: '_1J8DiqRE',
    ' _key': 'apic-theme/apic/card/tgf'
};
export default css;
